import styled, { css } from 'styled-components';
const loadingBarCss = css `
  background-color: ${({ theme: { colors }, $variant }) => {
    switch ($variant) {
        case 'secondary':
            return colors['blue-200'];
        case 'outline':
            return colors['blue-200'];
        case 'disabled':
            return colors['gray-300'];
        case 'login':
            return colors['teal-700'];
        case 'destructive':
            return colors['red-700'];
        case 'primary':
        default:
            return colors['blue-900'];
    }
}};

  position: absolute;
  height: 100%;
`;
/**
 * When `loading` is true or a number less than 0 or greater than 100,
 * the indeterminate progress bar styles will be used.
 * When `isLoading` is a number between 0 and 100, the determinate
 * progress bar will be used.
 */
export const LoadingBar = styled.div `
  ${loadingBarCss}

  ${({ $loading }) => typeof $loading === 'number'
    ? `width: ${$loading}%;
        left: 0;
        transition: width 0.3s;`
    : `width: 60%;
        position: absolute;
      
        left: -60%;
        animation: load 2s ease infinite;

        @keyframes load {
          0% {
            left: -60%;
          }
          100% {
            left: 100%;
          }
        }
  `}
`;
//# sourceMappingURL=LoadingBar.js.map